import { Navigate } from "react-router-dom";
import { PAGE_TITLES } from "@miplatform/constants";
import { Bids } from "../../views/Estimating/Bids/Bids";
import { BidsList } from "../../views/Estimating/Bids/BidsList";
import { CreateBid } from "../../views/Estimating/Bids/CreateBid/CreateBid";
import { CreateBidRequest } from "../../views/Estimating/Bids/CreateBidRequest/CreateBidRequest";
import { AddAreaType } from "../../views/Estimating/Configuration/AreaTypes/AddAreaType/AddAreaType";
import { AreaTypes } from "../../views/Estimating/Configuration/AreaTypes/AreaTypes";
import { AddAttributes } from "../../views/Estimating/Configuration/Attributes/AddAttributes/AddAttributes";
import { Attributes } from "../../views/Estimating/Configuration/Attributes/Attributes";
import { AddCategories } from "../../views/Estimating/Configuration/Categories/AddCategories/AddCategories";
import { Categories } from "../../views/Estimating/Configuration/Categories/Categories";
import { AddItems } from "../../views/Estimating/Configuration/Items/AddItems/AddItems";
import { Items } from "../../views/Estimating/Configuration/Items/Items";
import { AddRequirements } from "../../views/Estimating/Configuration/Requirements/AddRequirements/AddRequirements";
import { Requirements } from "../../views/Estimating/Configuration/Requirements/Requirements";
import { CustomerPricingDetails } from "../../views/Estimating/Pricing/Customers/CustomerPricingDetails/CustomerPricingDetails";
import { Customers } from "../../views/Estimating/Pricing/Customers/Customers";
import { AddDropType } from "../../views/Estimating/Pricing/DropTypes/AddDropType/AddDropType";
import { DropTypes } from "../../views/Estimating/Pricing/DropTypes/DropTypes";
import { PricingMatrix } from "../../views/Estimating/Pricing/PricingMatrix/PricingMatrix";
import { Series } from "../../views/Estimating/Pricing/Series/Series";
import { SeriesDetail } from "../../views/Estimating/Pricing/Series/SeriesDetail/SeriesDetail";

export const estimatingRoutes = [
  // CONFIGURATION
  {
    path: "/estimating/configuration",
    name: "Configuration",
    exact: true,
    element: <Navigate to="items" replace />,
  },
  {
    path: "/estimating/configuration/items",
    name: "Items",
    element: <Items />,
    handle: { title: PAGE_TITLES.ITEMS },
  },
  {
    path: "/estimating/configuration/categories",
    name: "Categories",
    element: <Categories />,
    handle: { title: PAGE_TITLES.CATEGORIES },
  },
  {
    path: "/estimating/configuration/attributes",
    name: "Attributes",
    element: <Attributes />,
    handle: { title: PAGE_TITLES.ATTRIBUTES },
  },
  {
    path: "/estimating/configuration/area-types",
    name: "Area Types",
    element: <AreaTypes />,
    handle: { title: PAGE_TITLES.AREAS },
  },
  {
    path: "/estimating/configuration/add-items",
    name: "Add Items",
    element: <AddItems />,
    handle: { title: PAGE_TITLES.ADD_ITEM },
  },
  {
    path: "/estimating/configuration/items/:id",
    name: "Edit Items",
    element: <AddItems />,
    handle: { title: PAGE_TITLES.ITEM },
  },
  {
    path: "/estimating/configuration/add-categories",
    name: "Add Categories",
    element: <AddCategories />,
    handle: { title: PAGE_TITLES.ADD_CATEGORY },
  },
  {
    path: "/estimating/configuration/categories/:id",
    name: "Edit Categories",
    element: <AddCategories />,
    handle: { title: PAGE_TITLES.CATEGORY },
  },
  {
    path: "/estimating/configuration/add-attributes",
    name: "Add Attributes",
    element: <AddAttributes />,
    handle: { title: PAGE_TITLES.ADD_ATTRIBUTE },
  },
  {
    path: "/estimating/configuration/attributes/:id",
    name: "Edit Attributes",
    element: <AddAttributes />,
    handle: { title: PAGE_TITLES.ATTRIBUTE },
  },
  {
    path: "/estimating/configuration/add-area-types",
    exact: true,
    name: "Add Area Type",
    element: <AddAreaType />,
    handle: { title: PAGE_TITLES.ADD_AREA },
  },
  {
    path: "/estimating/configuration/area-types/:id",
    exact: true,
    name: "Edit Area Type",
    element: <AddAreaType />,
    handle: { title: PAGE_TITLES.AREA },
  },
  {
    path: "/estimating/configuration/requirements",
    name: "Requirements",
    element: <Requirements />,
    handle: { title: PAGE_TITLES.REQUIREMENTS },
  },
  {
    path: "/estimating/configuration/add-requirements",
    name: "Add Requirement",
    element: <AddRequirements />,
    handle: { title: PAGE_TITLES.ADD_REQUIREMENT },
  },
  {
    path: "/estimating/configuration/requirements/:id",
    name: "Edit Requirement",
    element: <AddRequirements />,
    handle: { title: PAGE_TITLES.REQUIREMENT },
  },
  // PRICING
  {
    path: "/estimating/pricing",
    name: "Pricing",
    exact: true,
    element: <Navigate to="customers" replace />,
  },
  {
    path: "/estimating/pricing/customers",
    name: "Customers",
    element: <Customers />,
    handle: { title: PAGE_TITLES.PRICING },
  },
  {
    path: "/estimating/pricing/customers/:id",
    exact: true,
    name: "Customer Pricing",
    element: <Navigate to="PriceLevel" replace />,
    handle: { title: PAGE_TITLES.CUSTOMER_PRICING },
  },
  {
    path: "/estimating/pricing/customers/:id/:tab",
    name: "Customer Pricing",
    element: <CustomerPricingDetails />,
    handle: { title: PAGE_TITLES.CUSTOMER_PRICING },
  },
  {
    path: "/estimating/pricing/series",
    name: "Series",
    element: <Series />,
    handle: { title: PAGE_TITLES.SERIES },
  },
  {
    path: "/estimating/pricing/series/:id",
    name: "Series Detail",
    element: <SeriesDetail />,
    handle: { title: PAGE_TITLES.SERIES_DETAIL },
  },
  {
    path: "/estimating/pricing/drop-types",
    name: "Drop Types",
    element: <DropTypes />,
    handle: { title: PAGE_TITLES.DROP_TYPES },
  },
  {
    path: "/estimating/pricing/add-drop-types",
    name: "Add Drop Type",
    element: <AddDropType />,
    handle: { title: PAGE_TITLES.ADD_DROP_TYPE },
  },
  {
    path: "/estimating/pricing/drop-types/:id",
    name: "Edit Drop Type",
    element: <AddDropType />,
    handle: { title: PAGE_TITLES.DROP_TYPE },
  },
  {
    path: "/estimating/pricing/pricing-matrix",
    name: "Pricing Matrix",
    element: <PricingMatrix />,
    handle: { title: PAGE_TITLES.PRICING },
  },
  // BIDS
  {
    path: "/estimating/bids",
    element: <Navigate to="list/new" replace />,
  },
  {
    path: "/estimating/bids/list",
    name: "Search Bid Requests",
    element: <Bids />,
    handle: { title: PAGE_TITLES.BID_REQUESTS },
  },
  {
    path: "/estimating/bids/list/:tab",
    name: "Bid Requests",
    element: <BidsList />,
    handle: { title: PAGE_TITLES.BID_REQUESTS },
  },
  {
    path: "/estimating/bids/create/:bidId",
    name: "Edit Bid",
    element: <CreateBid />,
    handle: { title: PAGE_TITLES.BID },
  },
  {
    path: "/estimating/bids/create-bid-request",
    name: "Create Bid Request",
    element: <CreateBidRequest />,
    handle: { title: PAGE_TITLES.BID },
  },
];
